import {
    SHOW_SAVE_TO_FOLDER,
    SHOW_SAVE_ITEM,
    CALLOUT_KEYS,
} from '../pdp/PdpRespNotifications/pdpRespNotificationConstants';

import {
    SHOW_MULTI_PDP_VISITS,
    CALLOUT_KEYS as SHARED_CALLOUT_KEYS,
} from '../pdp/PdpSharedNotifications/pdpSharedNotificationConstants';

export default function(state, action) {
    switch (action.type) {
        case SHOW_SAVE_TO_FOLDER:
            return {
                ...state,
                callouts: { [CALLOUT_KEYS.SAVE_TO_FOLDER]: true },
            };
        case SHOW_SAVE_ITEM:
            return {
                ...state,
                callouts: { [CALLOUT_KEYS.SAVE_ITEM]: true },
            };
        case SHOW_MULTI_PDP_VISITS:
            return {
                ...state,
                callouts: { [SHARED_CALLOUT_KEYS.MULTI_PDP_VISITS]: true },
            };
        default:
            return state || { callouts: {} };
    }
}
